import { useTranslation } from "react-i18next";

import { TIMEFRAMES } from "./dateUtils";
import type { ChartTimeframe } from "./types";

export interface TimeframeToolbarProps {
  timeframe: ChartTimeframe;
  rangeExtensionDays: number;
  onTimeframeChange: (tf: ChartTimeframe) => void;
  onRangeExtensionChange: (days: number) => void;
}

export function TimeframeToolbar({
  timeframe,
  rangeExtensionDays,
  onTimeframeChange,
  onRangeExtensionChange,
}: TimeframeToolbarProps) {
  const { t } = useTranslation("dashboard");
  return (
    <div className="flex items-center gap-2" data-testid="timeframe-toolbar">
      <div role="group" aria-label={t("chart.timeframeLabel")} className="flex gap-1">
        {TIMEFRAMES.map((tf) => (
          <button
            key={tf}
            type="button"
            aria-pressed={tf === timeframe}
            onClick={() => onTimeframeChange(tf)}
            className={
              "px-3 py-1 text-sm rounded border " +
              (tf === timeframe ? "bg-foreground text-background" : "bg-transparent")
            }
          >
            {tf}
          </button>
        ))}
      </div>
      <div role="group" aria-label={t("chart.rangeExtensionLabel")} className="flex gap-1">
        <button
          type="button"
          onClick={() => onRangeExtensionChange(rangeExtensionDays + 7)}
          className="px-2 py-1 text-xs rounded border"
        >
          {t("chart.plusWeek")}
        </button>
        <button
          type="button"
          onClick={() => onRangeExtensionChange(rangeExtensionDays + 30)}
          className="px-2 py-1 text-xs rounded border"
        >
          {t("chart.plusMonth")}
        </button>
      </div>
    </div>
  );
}
